import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ErrorPage } from '../ErrorPage';
export const NOT_FOUND_MESSAGE = 'Unfortunately we could not find the page you are looking for';
export const NotFoundPage = memo(function NotFoundPage({ showContactText }) {
    return (_jsx(ErrorPage, { title: "404", message: NOT_FOUND_MESSAGE, showContactText: showContactText }, void 0));
});
